import Hls from 'hls.js/dist/hls.light.mjs';
import Player from '@vimeo/player';

/* -------------------------------
Mux Streaming (video[data-playback-id])
------------------------------- */
// Streams a Mux video with adaptive quality: it starts on a small rendition
// and steps up as bandwidth allows, capped to the size it's shown at.
function attachStream(video) {
	if (video.dataset.attached) return;
	video.dataset.attached = 'true';
	// Capped at 1080p: plenty for muted loops, and keeps 4K uploads from streaming at 4K.
	const src = `https://stream.mux.com/${video.dataset.playbackId}.m3u8?max_resolution=1080p`;
	if (Hls.isSupported()) {
	const hls = new Hls({ capLevelToPlayerSize: true });
	hls.loadSource(src);
	hls.attachMedia(video);
	video.hls = hls;
	return hls;
	} else {
	// Safari and iOS play HLS natively.
	video.src = src;
	}
}
window.attachStream = attachStream;

// Only start streaming when a video is about a screen away from the viewport.
const observer = new IntersectionObserver(entries => {
	entries.forEach(entry => {
	if (!entry.isIntersecting) return;
	attachStream(entry.target);
	observer.unobserve(entry.target);
	});
}, { rootMargin: '100% 0px' });

document.querySelectorAll('video[data-playback-id]').forEach(video => observer.observe(video));

/* -------------------------------
Vimeo Click-to-Play (.vimeo)
------------------------------- */
// Shows a still or a muted Mux preview until clicked, then plays the Vimeo video in its place.
// When the Vimeo video ends, the preview comes back.
document.querySelectorAll('.vimeo').forEach(element => {
	const preview = element.querySelector('img, video');
	const button = element.querySelector('.vimeo-play');

	function showPreview(show) {
	preview.style.display = show ? '' : 'none';
	button.style.display = show ? '' : 'none';
	element.style.cursor = show ? '' : 'auto';
	if (preview.tagName !== 'VIDEO') return;
	if (show) {
		if (preview.hls) preview.hls.startLoad();
		preview.play().catch(() => {});
	} else {
		preview.pause();
		if (preview.hls) preview.hls.stopLoad();
	}
	}

	element.addEventListener('click', () => {
	if (element.querySelector('iframe')) return;
	showPreview(false);
	const iframe = document.createElement('iframe');
	iframe.src = element.dataset.vimeoSrc + '&autoplay=1';
	iframe.allow = 'autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share';
	iframe.referrerPolicy = 'strict-origin-when-cross-origin';
	iframe.title = element.dataset.title;
	element.appendChild(iframe);

	const player = new Player(iframe);
	player.on('ended', () => {
		player.destroy();
		showPreview(true);
	});
	});
});
